"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartWifiProvisioningRequestT = exports.StartWifiProvisioningRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class StartWifiProvisioningRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStartWifiProvisioningRequest(bb, obj) {
        return (obj || new StartWifiProvisioningRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStartWifiProvisioningRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StartWifiProvisioningRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    ssid(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    password(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    port(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startStartWifiProvisioningRequest(builder) {
        builder.startObject(3);
    }
    static addSsid(builder, ssidOffset) {
        builder.addFieldOffset(0, ssidOffset, 0);
    }
    static addPassword(builder, passwordOffset) {
        builder.addFieldOffset(1, passwordOffset, 0);
    }
    static addPort(builder, portOffset) {
        builder.addFieldOffset(2, portOffset, 0);
    }
    static endStartWifiProvisioningRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStartWifiProvisioningRequest(builder, ssidOffset, passwordOffset, portOffset) {
        StartWifiProvisioningRequest.startStartWifiProvisioningRequest(builder);
        StartWifiProvisioningRequest.addSsid(builder, ssidOffset);
        StartWifiProvisioningRequest.addPassword(builder, passwordOffset);
        StartWifiProvisioningRequest.addPort(builder, portOffset);
        return StartWifiProvisioningRequest.endStartWifiProvisioningRequest(builder);
    }
    unpack() {
        return new StartWifiProvisioningRequestT(this.ssid(), this.password(), this.port());
    }
    unpackTo(_o) {
        _o.ssid = this.ssid();
        _o.password = this.password();
        _o.port = this.port();
    }
}
exports.StartWifiProvisioningRequest = StartWifiProvisioningRequest;
class StartWifiProvisioningRequestT {
    constructor(ssid = null, password = null, port = null) {
        this.ssid = ssid;
        this.password = password;
        this.port = port;
    }
    pack(builder) {
        const ssid = (this.ssid !== null ? builder.createString(this.ssid) : 0);
        const password = (this.password !== null ? builder.createString(this.password) : 0);
        const port = (this.port !== null ? builder.createString(this.port) : 0);
        return StartWifiProvisioningRequest.createStartWifiProvisioningRequest(builder, ssid, password, port);
    }
}
exports.StartWifiProvisioningRequestT = StartWifiProvisioningRequestT;
